import React from 'react';
import { Text, View } from 'react-native';

export default class ExpoBarCodeScannerView extends React.Component<object> {
  render() {
    return (
      <View>
        <Text>BarCodeScanner Component not supported on the web</Text>
      </View>
    );
  }
}
